<script lang="ts">
    import { onMount } from 'svelte';

    import cn from '$common/utils/cn';
    import Button from '$saga/components/Button.svelte';
    import { filtersContext } from '$saga/views/Search/store';
    import { resetLabels, resetValues } from './utils';

    export let searchResultTotal: number,
        hideButtons: boolean = false,
        searchDatalayer: string = '',
        dict: any;

    onMount(() => {
        if (searchResultTotal === 0 && window.dataLayer) {
            window.dataLayer.push(JSON.parse(searchDatalayer));
        }
    });
</script>

<div
    class={cn(
        'relative  my-m flex flex-col justify-between px-5xl desktop:flex-row',
        hideButtons && 'hidden',
    )}
>
    <div
        class="mx-auto w-fit text-center text-[22px] font-semibold desktop:text-[26px]"
    >
        {#if searchResultTotal}
            <span class="placeholder italic text-content-brand">
                {dict.count}
            </span>
            <span class="">{dict.suffix}</span>
        {/if}
    </div>
</div>

{#if searchResultTotal === 0}
    <div
        class="mx-l mb-2xl flex max-w-layout-max flex-col items-center justify-center gap-m bg-white p-l desktop:mx-5xl"
    >
        <span class="text-center">
            Oups 😬 Aucun séjour ne correspond à votre recherche
        </span>

        <Button
            intent="tertiary"
            size="small"
            class="text-caption underline hover:no-underline"
            on:click={() => {
                $filtersContext.formLabels = resetLabels();
                $filtersContext.formValues = resetValues();

                // trigger form with event
                const form = document.getElementById(
                    'travel-search-engine-form',
                );
                if (form) {
                    setTimeout(() => {
                        form.submit();
                    }, 0);
                }
            }}
        >
            Effacer les filtres
        </Button>
    </div>
{/if}
